import { c as _c } from "react-compiler-runtime";
import { createContext, useContext, useMemo } from 'react';
import { createBusinessUnitSelectChangeTracker, setupTracker } from 'framework-listing-lib/utils/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
const TrackerContext = /*#__PURE__*/createContext(undefined);
export default function TrackerProvider(t0) {
  "use memo";

  const $ = _c(17);
  const {
    applicationId,
    children,
    onTrackEvent,
    tracker
  } = t0;
  let t1;
  if ($[0] !== tracker) {
    t1 = tracker ? createBusinessUnitSelectChangeTracker(tracker) : undefined;
    $[0] = tracker;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const trackBusinessUnitSelectChange = t1;
  let t2;
  let t3;
  let t4;
  if ($[2] !== applicationId || $[3] !== onTrackEvent || $[4] !== tracker) {
    const trackerInstance = setupTracker(tracker);
    t2 = applicationId;
    t3 = onTrackEvent;
    t4 = trackerInstance === null || trackerInstance === void 0 ? void 0 : trackerInstance.track.bind(trackerInstance);
    $[2] = applicationId;
    $[3] = onTrackEvent;
    $[4] = tracker;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== trackBusinessUnitSelectChange || $[12] !== tracker) {
    t5 = {
      applicationId: t2,
      onTrackEvent: t3,
      track: t4,
      trackBusinessUnitSelectChange,
      consumerTracker: tracker
    };
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = trackBusinessUnitSelectChange;
    $[12] = tracker;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const value = t5;
  let t6;
  if ($[14] !== children || $[15] !== value) {
    t6 = /*#__PURE__*/_jsx(TrackerContext.Provider, {
      value: value,
      children: children
    });
    $[14] = children;
    $[15] = value;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}
export function useTracker() {
  "use memo";

  const context = useContext(TrackerContext);
  if (context === undefined) {
    throw new Error("useTracker must be used within a TrackerProvider");
  }
  return context;
}